export default __webpack_public_path__ + "static/media/independent-grocery-shops.20b5832f.png";